exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#admin-view .trash{color:#d15b47}#admin-view .user-list li{display:flex;border:none;border-bottom:1px #d3d3d3 solid;margin-bottom:0}#admin-view .user-list li:last-child{border-bottom:none}#admin-view .user-list li .user-info{flex-grow:1}#admin-view .user-list li .trash{display:flex;align-items:center;text-decoration:none}", ""]);

